import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const TourDate = styled.div`
  color: ${colors.whaleGrey};

  span {
    visibility: hidden;
  }
`;

TourDate.displayName = "TourDate";

export { TourDate };
